import { render, staticRenderFns } from "./ModalAprovar.vue?vue&type=template&id=5dd4f8c7"
import script from "./ModalAprovar.vue?vue&type=script&lang=js"
export * from "./ModalAprovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports